// Per-SKU display metadata for the cart, persisted in sessionStorage so
// page refreshes don't blank-out the line (color/size/image/price).
//
// Truth lives in NetSuite once the order or quote is created; this is
// purely UI sugar for the in-progress cart on the SPA.

const KEY = "mr.b2b.cartMeta";

function loadAll() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

function saveAll(map) {
  try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch { /* quota */ }
}

export function rememberCartMeta(sku, meta) {
  if (!sku || !meta) return;
  const all = loadAll();
  all[sku] = { ...(all[sku] || {}), ...meta };
  saveAll(all);
}

export function recallCartMeta(sku) {
  if (!sku) return null;
  return loadAll()[sku] || null;
}

export function clearCartMeta() {
  try { sessionStorage.removeItem(KEY); } catch { /* */ }
}

// Save-for-later list — separate from the cart but uses the same meta cache.
const SFL_KEY = "mr.b2b.savedForLater";

export function getSavedForLater() {
  try {
    const raw = sessionStorage.getItem(SFL_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

export function saveForLater(line) {
  const list = getSavedForLater();
  if (!list.find((x) => x.sku === line.sku)) {
    list.push(line);
    try { sessionStorage.setItem(SFL_KEY, JSON.stringify(list)); } catch { /* */ }
  }
}

export function removeFromSaved(sku) {
  const list = getSavedForLater().filter((x) => x.sku !== sku);
  try { sessionStorage.setItem(SFL_KEY, JSON.stringify(list)); } catch { /* */ }
  return list;
}
